/**
 * @Description 任务历史 目前看来卡旺卡和普通拓店任务处理无差异
 */
import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Form, Modal, Typography } from 'antd';
import { useMethods } from '@lhb/hook';
import SearchForm from '@/common/components/Form/SearchForm';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2Table from '@/common/components/Data/V2Table';
import ExpansionFranchiseeCircleTaskDrawer from '../Drawer';
import { taskHistory } from '@/common/api/expandStore/expansiontask';
import { isArray, isNotEmptyAny } from '@lhb/func';
import styles from '../index.module.less';
import { TaskStatusColor } from '@/common/components/business/ExpandStore/ts-config';

const { Link } = Typography;

interface Props {
  expansionTaskAlias: string; // 拓店任务别名
  ref?: any;
}

// eslint-disable-next-line no-empty-pattern
const TaskHistory : FC<Props> = forwardRef(({ expansionTaskAlias }, ref) => {
  const detailRef: any = useRef();
  const [form] = Form.useForm(); // 表单参数
  const [filters, setFilters] = useState<any>(); // 筛选参数
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false); // 弹出框是否打开

  useImperativeHandle(ref, () => ({
    init
  }));

  const init = (id) => {
    setId(id);
    setOpen(true);
  };

  const methods = useMethods({
    /**
     * @description 点击-取消，或者点击任务后关闭当前弹框
     */
    onClose() {
      setOpen(false);
      setFilters({});
      form.resetFields();
    },

    handleTask(id: number) {
      this.onClose();
      detailRef.current?.init(id);
    },

    /**
     * @description 搜索
     * @param params 搜索关键词
     */
    onSearch(params) {
      setFilters(params);
    },

    /**
     * @description 加载表格数据，输入关键字时由前端过滤
     * @param params 搜索参数
     * @returns 表格数据
     */
    async loadData(params) {
      const data = await taskHistory({ id });

      const keyword = params.name;
      const dataSource = isArray(data) ? data.filter((itm: any) => !keyword || itm.name.includes(keyword)) : [];
      return {
        dataSource,
        count: dataSource.length,
      };
    }
  });

  const defaultColumns = [{
    key: 'name',
    title: `${expansionTaskAlias || '任务'}名称`,
    width: '280px',
    render: (value, record) => (<Link onClick={() => methods.handleTask(record.id)}>{value}</Link>)
  }, {
    key: 'status',
    title: `${expansionTaskAlias || '任务'}状态`,
    dragChecked: true,
    width: '120px',
    render: (value, record) => {
      return isNotEmptyAny(value) ? (
        <div className={styles.taskStatusColumn}>
          <span
            className={styles.taskStatusIcon}
            style={{
              backgroundColor: TaskStatusColor[value],
            }}
          />
          {record.statusName}
        </div>
      ) : '-';
    },
  }];

  return (
    <>
      <Modal
        title={`${expansionTaskAlias || '任务'}历史`}
        open={open}
        width={680}
        onCancel={methods.onClose}
        destroyOnClose
        footer={null}
        wrapClassName={styles.historyModal}
      >
        <SearchForm
          onOkText='搜索'
          form={form}
          showResetBtn
          onSearch={methods.onSearch}
        >
          <V2FormInput label='' name='name' placeholder={`请输入${expansionTaskAlias || '任务'}名称`}/>
        </SearchForm>

        <V2Table
          rowKey='id'
          defaultColumns={defaultColumns}
          onFetch={methods.loadData}
          pagination={false}
          hideColumnPlaceholder={true}
          filters={filters}
          scroll={{ x: 'max-content', y: 380 }}
        />
      </Modal>
      <ExpansionFranchiseeCircleTaskDrawer
        ref={detailRef}
        isHistory={true}
        hideOperate={true}
        hideClusterDetail={true}
      />
    </>
  );
});
export default TaskHistory;

